import React, { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// components
import DatePicker from 'components/date-picker';

interface OwnProps {
  name: string;
  label?: string;
  fullWidth?: boolean;
  placeholder?: string;
  icon?: boolean;
  additionalOnChange?: (value: string) => void;
  [x: string]: any;
  defaultCalendarMonth?: Date;
  disablePast?: boolean;
  withError?: boolean;
  disabled?: boolean;
  shouldUnregister?: boolean;
}

const DatePickerController: React.FC<OwnProps> = ({
  name = '',
  withError = false,
  defaultCalendarMonth,
  disablePast,
  shouldUnregister,
  ...props
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      shouldUnregister={shouldUnregister}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        return (
          <DatePicker
            name={name}
            value={value}
            {...props}
            error={!!error}
            helperText={withError ? error?.message || ' ' : undefined}
            onChange={props?.additionalOnChange ? props?.additionalOnChange : onChange}
            defaultCalendarMonth={defaultCalendarMonth}
            disablePast={!!disablePast}
          />
        );
      }}
      name={name}
      control={control}
    />
  );
};

export default memo(DatePickerController);
